import { useCallback } from 'react'
import GenericTabsSmall from '../../genericTabs/GenericTabsSmall'
import { Badge, Box, Paper, Typography } from '@mui/material'
import { useStyles } from './styles'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { GlobalNotificationTab, setGlobalNotificationTab } from '../../../reducer/globalNotification.reducer'
import { selectGlobalNotificationTab, selectGlobalNotifications } from '../../../selectors/globalNotification'
import { GlobalNotificationType } from '../../../proto/generated/global-notification'

const GlobalNotificationHeader = () => {
    const { classes } = useStyles()
    const dispatch = useDispatch()
    const selectedGlobalNotificationTab = useSelector(selectGlobalNotificationTab)
    const notifications = useSelector(selectGlobalNotifications)

    const systemNotificationsCount = notifications.filter(
        (n) => n.type === GlobalNotificationType.SYSTEM_NOTIFICATION
    ).length

    const productAnnouncementsCount = notifications.filter(
        (n) => n.type === GlobalNotificationType.PRODUCT_ANNOUNCEMENT
    ).length

    const navItems = [
        {
            key: GlobalNotificationTab.SYSTEM_NOTIFICATION,
            label: renderTabLabel('System Alerts', systemNotificationsCount)
        },
        {
            key: GlobalNotificationTab.PRODUCT_ANNOUNCEMENT,
            label: renderTabLabel('Updates', productAnnouncementsCount)
        }
    ]

    function renderTabLabel(label: string, count: number) {
        return (
            <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
                {label}
                {count > 0 && (
                    <Badge
                        badgeContent={count}
                        color="primary"
                        sx={{
                            '& .MuiBadge-badge': {
                                fontSize: '0.7rem',
                                minWidth: 18,
                                height: 18
                            }
                        }}
                    />
                )}
            </Box>
        )
    }

    const handleGlobalNotificationTypeChange = useCallback(
        (value: GlobalNotificationTab) => {
            if (
                [GlobalNotificationTab.PRODUCT_ANNOUNCEMENT, GlobalNotificationTab.SYSTEM_NOTIFICATION].includes(value)
            ) {
                dispatch(setGlobalNotificationTab(value))
            }
        },
        [dispatch]
    )

    return (
        <Paper className={classes.container}>
            <GenericTabsSmall<GlobalNotificationTab>
                items={navItems}
                onChange={handleGlobalNotificationTypeChange}
                value={selectedGlobalNotificationTab}
                tabProps={{
                    className: classes.tab
                }}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    backgroundColor: (theme) => theme.palette.background.default
                }}
            />
        </Paper>
    )
}

export default GlobalNotificationHeader
